import { Model as ORMModel, attr, fk, many } from 'redux-orm'
import { Types } from '@fedsim/actions'
import { getId } from '@fedsim/helpers'

export default class Model extends ORMModel {
  static get fields() {
    return {
      id: attr(),

      name: attr({ getDefault: () => '' }),
      image: attr({ getDefault: () => '' }),

      entryIds: many({
        to: 'Wrestler',
        as: 'entries',
        relatedName: 'RumbleEntries'
      }),
      enteredIds: many({
        to: 'Wrestler',
        as: 'entered',
        relatedName: 'RumbleEntered'
      }),
      eliminatedIds: many({
        to: 'Wrestler',
        as: 'eliminations',
        relatedName: 'RumbleEliminations'
      }),
      eliminatedByIds: many({
        to: 'Wrestler',
        as: 'eliminatedBy',
        relatedName: 'RumbleEliminatedBy'
      }),
      winnerId: fk({
        to: 'Wrestler',
        as: 'winner',
        relatedName: 'RumbleWinner'
      }),

      duration: attr({ getDefault: () => 60 * 60 }),

      color: attr({ getDefault: () => '#000' }),
      backgroundColor: attr({ getDefault: () => '#fff' }),

      active: attr({ getDefault: () => false }),
      complete: attr({ getDefault: () => false }),
    }
  }
  static reducer(action, Rumble, session) {
    let item
    switch (action.type) {
      default:
        break
      case Types.RESET:
      case Types.RESET_RUMBLES:
        session.Rumble.all()
          .toModelArray()
          .forEach(item => item.delete())
        break
      case Types.GENERATE_RUMBLES:
        action?.payload?.forEach(newItem => {
          session.Rumble.upsert(newItem)
        })
        break
      case Types.ADD_RUMBLE:
        const id = action?.payload?.id || getId()
        Rumble.upsert({ id, ...action.payload })
        break
      case Types.UPDATE_RUMBLE:
        item = Rumble.withId(action.payload.id)
        item.update(action.payload)
        break
      case Types.DELETE_RUMBLE:
        Rumble.withId(action.payload.id).delete()
        break
      case Types.RUMBLE_START:
        item = Rumble.withId(action.payload.id)
        item.update({ active: true })
        break

      case Types.RUMBLE_COMPLETE: {
        item = Rumble.withId(action.payload.id)
        const fields = item?._fields

        const inRing = fields?.enteredIds?.filter(id => !item?.eliminatedIds?.includes(id))
        const winnerId = inRing?.[0]

        item.update({ complete: true, winnerId })
      } break
      case Types.RUMBLE_ENTER:
        item = Rumble.withId(action?.payload?.id)
        item.update({
          enteredIds: [...new Set([...item?.enteredIds, action?.payload?.wrestlerId])]
        })
        break
      case Types.RUMBLE_ELIMINATE: {
        const item = Rumble.withId(action?.payload?.id)
        const fields = item?._fields

        if (item?.complete || !item?.active) {
          break
        }

        const inRing = fields?.enteredIds?.filter(id => !item?.eliminatedIds?.includes(id))

        if (inRing.length > 1) {
          const eliminated = inRing[Math.floor(Math.random() * inRing?.length)]
          const eliminatedIds = [...new Set(item?.eliminatedIds?.concat(eliminated))]

          item.update({ eliminatedIds })
        }
        item.update({ duration: item.duration + 60 })
      }
      break
    }
  }
}


/*

    wrestlerId: null,
    active: false,
    duration: 0,
    eliminatedBy: false,
  },
  rumble: {
    id: "",
    title: "",
    description: "",
    date: new Date(),
    brandIds: [],
    entries: [],
    male: true,
    winnerId: null,
    active: false,
  },

import * as Types from "actions/types"

import { getId, schema, } from "model"

const defaultState = []


export default (state = defaultState, action) => {
  let draft = [...state,]
  let index

  switch (action.type) {
    case Types.RESET:
    case Types.RESET_RUMBLES:
      draft = defaultState
      break

    case Types.RESET_RUMBLE:
      index = draft.findIndex((item) => item.id === action.payload)

      if (index > -1) {
        draft[index] = { ...schema.rumble, id: action.payload, winnerId: false, }
      }
      break
    case Types.MODEL_COLLECTION:
      draft = draft.map((item) => Model(item))
      break

    case Types.GENERATE_RUMBLES:
      draft = draft.concat(action.payload.map((item) => Model(item)))
      draft = draft.filter((prev, i, self) => i === self.findIndex((next) => next.id === prev.id))
      break

    case Types.CREATE_RUMBLE:
      action.payload.id = action.payload.id ? action.payload.id : getId()

      draft.push(Model(action.payload))
      break

    case Types.UPDATE_RUMBLE:
      index = draft.findIndex((item) => item.id === action.payload.id)

      if (index > -1) {
        draft[index] = Model({ ...draft[index], ...action.payload, })
      } else if (action.payload.id) {
        draft.push(Model(action.payload))
      }
      break

    case Types.DELETE_RUMBLE:
      draft = draft.filter((item) => item.id !== action.payload)
      break
  }

  return draft
}


*/
